import {Component} from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";

@Component({
  selector: 'go-tags',
  templateUrl: './go-tags.component.html',
  styles: []
})
export class GoTagsComponent extends GoBaseComponent{

  GO_COMPONENTS = GO_COMPONENTS;
  constructor() {
    super(GO_COMPONENTS.TAGS);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-tags/go-tags.component.ts